"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _grid = require("@jsluna/grid");

var _QuestionComponent = _interopRequireDefault(require("./QuestionComponent"));

var _button = require("@jsluna/button");

var _icons = require("@jsluna/icons");

var _form = require("@jsluna/form");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var QuestionPreview = function QuestionPreview(_ref) {
  var _question$component, _question$component$p;

  var question = _ref.question,
      setEditMode = _ref.setEditMode;
  return /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1",
    className: "ln-u-text-align-right ln-u-padding-bottom"
  }, /*#__PURE__*/_react.default.createElement(_button.IconButton, {
    variant: "outlined",
    onClick: function onClick() {
      return setEditMode(question.id);
    },
    label: "Edit"
  }, /*#__PURE__*/_react.default.createElement(_icons.Edit, null))), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1"
  }, /*#__PURE__*/_react.default.createElement(_form.FormGroup, {
    name: question.id + "-form-group-preview",
    label: question.position + ". " + question.title + " " + ((question == null ? void 0 : (_question$component = question.component) == null ? void 0 : (_question$component$p = _question$component.props) == null ? void 0 : _question$component$p.required) === false ? '(optional)' : ''),
    info: /*#__PURE__*/_react.default.createElement("span", null, question.description)
  }, /*#__PURE__*/_react.default.createElement(_QuestionComponent.default, {
    disabled: true,
    question: question
  }))));
};

QuestionPreview.propTypes = {
  /** Object containing the question information */
  question: _propTypes.default.PropTypes.shape({
    /** The unique identifier of the question */
    id: _propTypes.default.string,

    /** The position of the question in the survey */
    position: _propTypes.default.number,

    /** The title of the question */
    title: _propTypes.default.string,

    /** The supporting description of the question */
    description: _propTypes.default.string,

    /** The conditions a question has to be displayed */
    conditions: _propTypes.default.array,

    /** Information on the component to be rendered for the question */
    component: _propTypes.default.shape({
      /** The type of component the question should render */
      type: _propTypes.default.string,

      /** The props to be passed to the rendered question component */
      props: _propTypes.default.object
    }),

    /** Indicates whether the question is currently being edited */
    editMode: _propTypes.default.bool
  }).isRequired,

  /** Function to set the `editMode` of the question */
  setEditMode: _propTypes.default.func.isRequired
};
var _default = QuestionPreview;
exports.default = _default;